/*
 * Shared logic for the "book-pdp" (custom book product page) template.
 * Handles: hero buy box qty stepper + add-to-cart (single one-time purchase,
 * no selling plans), the sticky bottom bar, FAQ accordions, scroll-reveal
 * animations and the "wybor" video modal.
 *
 * All state lives in window.BookPDP so every book-pdp-*.liquid section can
 * read/update the same product selection without passing data between
 * Liquid files.
 */
if (window.BookPDP) {
  /* book-pdp.js is intentionally included by several book-pdp-*.liquid
     sections so each one works standalone. Every section on the same page
     loads (and executes) this same script tag again, so everything below
     must only run once. */
} else {
window.BookPDP = (function () {
  var state = {
    qty: 1,
    variantId: null,
    price: 0
  };

  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',');
  }

  function total() {
    return state.price * state.qty;
  }

  function getState() {
    return {
      qty: state.qty,
      unitFormatted: fmt(state.price),
      totalFormatted: fmt(total())
    };
  }

  function notify() {
    renderUI();
    document.dispatchEvent(new CustomEvent('book-pdp:state', { detail: getState() }));
  }

  function init(config) {
    state.variantId = config.variantId || state.variantId;
    state.price = config.price || 0;
    notify();
  }

  function setQty(qty) {
    state.qty = Math.max(1, Math.min(99, qty));
    notify();
  }

  function stepQty(delta) {
    setQty(state.qty + delta);
  }

  function addToCart(btn) {
    if (!state.variantId) return;
    var item = { id: state.variantId, quantity: state.qty };

    var originalText = null;
    if (btn) {
      originalText = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Dodawanie...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error((data && data.description) || 'Błąd dodawania do koszyka');
          });
        }
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('rc:cart:open', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('[book-pdp]', err);
        alert('Wystąpił błąd. Spróbuj ponownie.');
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          if (originalText !== null) btn.innerHTML = originalText;
        }
      });
  }

  function renderUI() {
    var s = getState();
    document.querySelectorAll('[data-book-qty-value]').forEach(function (el) {
      el.textContent = s.qty;
    });
    document.querySelectorAll('[data-book-price]').forEach(function (el) {
      el.textContent = s.totalFormatted;
    });
  }

  function initQtyButtons() {
    document.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-book-qty-decrease]');
      var inc = e.target.closest('[data-book-qty-increase]');
      if (dec) { e.preventDefault(); stepQty(-1); }
      if (inc) { e.preventDefault(); stepQty(1); }
    });
  }

  function initAddToCartButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-book-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      addToCart(btn);
    });
  }

  function initScrollTopButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-book-scroll-top]');
      if (!btn) return;
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function initAccordions() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-book-toggle]');
      if (!trigger) return;
      var item = trigger.closest('[data-book-accordion-item]');
      if (!item) return;
      var isOpen = item.classList.toggle('is-open');
      var sign = trigger.querySelector('[data-book-sign]');
      if (sign) sign.textContent = isOpen ? '−' : '+';
      var labelOpen = trigger.getAttribute('data-book-label-open');
      var labelClosed = trigger.getAttribute('data-book-label-closed');
      if (labelOpen && labelClosed) trigger.textContent = isOpen ? labelOpen : labelClosed;
    });
  }

  function initClampToggle() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-book-clamp-toggle]');
      if (!trigger) return;
      var item = trigger.closest('[data-book-clamp-item]');
      if (!item) return;
      var isExpanded = item.classList.toggle('is-clamp-expanded');
      var labelOpen = trigger.getAttribute('data-book-label-open');
      var labelClosed = trigger.getAttribute('data-book-label-closed');
      if (labelOpen && labelClosed) trigger.textContent = isExpanded ? labelOpen : labelClosed;
    });
  }

  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-book-reveal]').forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    function observe() {
      document.querySelectorAll('[data-book-reveal]:not(.is-revealed)').forEach(function (el) {
        io.observe(el);
      });
    }
    observe();
    var interval = setInterval(observe, 500);
    setTimeout(function () { clearInterval(interval); }, 4000);
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-book-stickybar]');
    var hero = document.querySelector('[data-book-hero]');
    if (!bar || !hero) return;
    var observer = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    });
    observer.observe(hero);
  }

  function initVideoModal() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-book-video-open]');
      if (opener) {
        e.preventDefault();
        var srcMp4 = opener.getAttribute('data-book-video-open');
        var srcWebm = opener.getAttribute('data-book-video-open-webm');
        var modal = document.querySelector('[data-book-video-modal]');
        if (!modal) return;
        var video = modal.querySelector('video');
        if (video) {
          var sourceWebm = video.querySelector('source[type="video/webm"]');
          var sourceMp4 = video.querySelector('source[type="video/mp4"]');
          if (sourceWebm) sourceWebm.src = srcWebm || '';
          if (sourceMp4) sourceMp4.src = srcMp4 || '';
          video.load();
        }
        modal.classList.add('is-open');
        if (video) { video.play().catch(function () {}); }
        return;
      }
      var closer = e.target.closest('[data-book-video-close]');
      var backdrop = e.target.closest('[data-book-video-modal]');
      if (closer || (backdrop && !e.target.closest('[data-book-video-panel]'))) {
        var openModal = document.querySelector('[data-book-video-modal].is-open');
        if (!openModal) return;
        var openVideo = openModal.querySelector('video');
        if (openVideo) { openVideo.pause(); }
        openModal.classList.remove('is-open');
      }
    });
  }

  function loadDeferredImage(img) {
    var srcset = img.getAttribute('data-book-srcset');
    var src = img.getAttribute('data-book-src');
    if (srcset) { img.setAttribute('srcset', srcset); img.removeAttribute('data-book-srcset'); }
    if (src) { img.setAttribute('src', src); img.removeAttribute('data-book-src'); }
  }

  function initHeroGallery() {
    /* Hidden slides sit inside the viewport, so loading="lazy" would not hold them back —
       their src is swapped in after the page has loaded, or on thumbnail click. */
    function loadAllDeferred() {
      document.querySelectorAll('[data-book-gallery] img[data-book-src]').forEach(loadDeferredImage);
    }
    window.addEventListener('load', function () {
      if ('requestIdleCallback' in window) requestIdleCallback(loadAllDeferred, { timeout: 3000 });
      else setTimeout(loadAllDeferred, 1500);
    });

    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-book-gallery-thumb]');
      if (!thumb) return;
      var gallery = thumb.closest('[data-book-gallery]');
      if (!gallery) return;
      var idx = thumb.getAttribute('data-book-gallery-thumb');
      gallery.querySelectorAll('[data-book-gallery-slide]').forEach(function (slide) {
        var active = slide.getAttribute('data-book-gallery-slide') === idx;
        slide.classList.toggle('is-active', active);
        if (active) {
          var img = slide.querySelector('img[data-book-src]');
          if (img) loadDeferredImage(img);
        }
      });
      gallery.querySelectorAll('[data-book-gallery-thumb]').forEach(function (t) {
        t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
      });
    });
  }

  function initDialogs() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-book-dialog-open]');
      if (opener) {
        var dialog = document.getElementById(opener.getAttribute('data-book-dialog-open'));
        if (dialog && typeof dialog.showModal === 'function') {
          e.preventDefault();
          dialog.showModal();
          opener.setAttribute('aria-expanded', 'true');
          dialog.addEventListener('close', function () {
            opener.setAttribute('aria-expanded', 'false');
          }, { once: true });
        }
        return;
      }
      var open = e.target.closest('dialog[open][data-book-dialog]');
      if (!open) return;
      if (e.target.closest('[data-book-dialog-close]') || e.target === open) open.close();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeroGallery();
    initDialogs();
    initQtyButtons();
    initAddToCartButtons();
    initScrollTopButtons();
    initAccordions();
    initClampToggle();
    initReveal();
    initStickyBar();
    initVideoModal();
    renderUI();
  });

  return { init: init, setQty: setQty, stepQty: stepQty, addToCart: addToCart, getState: getState, fmt: fmt };
})();
}
